import { render, staticRenderFns } from "./p.vue?vue&type=template&id=78954744&"
import script from "./p.vue?vue&type=script&lang=js&"
export * from "./p.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports